<template>
	<div class="main-content">
		<!-- main content area start -->
		<div class="main-content-inner">
			<div class="inner-frame" contenteditable="true">
				<div class="inner-overflow">
					<p>Click here to add text. Text on the first page is the title</p>
				</div>
			</div>
			<div class="inner-button">


				<button class="btn d-none-sm" @click="showModals()"  id="v-step-0">
					<img src="../assets/icon/plus-icon.svg" align="icon"> 
					<span>Add new page</span>
				</button>
				<ul>
					<li @click="showBtmBar()">
						<a href="#"><img src="../assets/icon/image-icon.svg" align="icon"></a>
					</li>
					<li>
						<a href="#">
							<img src="../assets/icon/Duplicate.svg" align="icon">
						</a>
					</li>
					<li>
						<a href="#">
							<img src="../assets/icon/trash-2.svg" align="icon">
						</a>
					</li>
				</ul>
			</div>
		</div>
		<!-- main content area end -->


	    <!-- add story modal modal -->
	    <modal v-if="showModal" @close="showModal = false" class="importText">
	    	<div slot="closeModal" @click="closeModal()">
	    		<i class="fas fa-times-circle"></i>
	    	</div>
	        <h3 slot="header">A series is awesome for:</h3>
	        <div slot="body">
	          <ul class="seriesFor">
	            <li>- making a story series</li>
	            <li>- adding chapters to your book</li>
	            <li>- organizing your poetry</li>
	          </ul>
	        </div>
	        <div slot="footer">       
	            <button class="modal-default-button" @click="closeStoryModal()">MAKE YOUR FIRST SERIES!</button>
	        </div>
	    </modal>
	    <!-- series is awesome end -->

	    <!-- add story modal start -->
	    <modal v-if="seriesModal" @close="seriesModal = false" class="importText addSeries">
	    	<div slot="closeModal" @click="closeModal()">
	    		<i class="fas fa-times-circle"></i>
	    	</div>
	        <p slot="header">Once you create the next part of the story, you can add it to this series and readerls will be easily able to follow the entire series! Just add a little and click Save!</p>
	        <div slot="body">
	          <div class="addTitle">
	            <span>Title: </span>
	            <input type="text" v-model="title" placeholder="Series Name">
	          </div>
	          <div class="allItemTitle">
	            <draggable 
	            v-model="dataList" 
		        @start="isDragging = true"
		        @end="isDragging = false">
	              <transition-group type="transition" name="flip-list">
	                <div class="singleStoryTitle" v-for="(data, index) in dataList" :key="data.id">
	                  <span>{{ index+1 }}</span>
	                  <p>{{data.name}}</p>
	                  <ul>
	                    <li style="cursor: move;"><img src="../assets/icon/move.svg" alt="move"></li>
	                    <li @click="removeTitle(data, index)"><img src="../assets/icon/minus-icon.svg" alt="minus-icon"></li>
	                  </ul>
	                </div>
	              </transition-group>
	            </draggable>
	            <!-- /.singleStoryTitle -->

	            <div class="singleStoryTitle addStory" @click="addTitle()">
	              <span><img src="../assets/icon/add-icon-gray.svg" alt="move"></span>
	              <p>Add another part to this series</p>
	            </div>
	            <!-- /.add story item -->

	          </div>
	        </div>
	        <div slot="footer" class="import-btn">        
	       
	            <button type="button" @click="seriesModalClose()" class="navitem">CANCEL</button>
	            <button type="button" @click="saveData()" class="navitem importBg">SAVE</button>
	           
	        </div>
	    </modal>
	    <!-- add story modal end -->


	</div>
</template>

<script>
	import draggable from 'vuedraggable';
	import { EventBus } from '../main';
	export default {
		name: "main-content",
		data() {
			return {
				btmBar:false,
		        showModal:false,
		        seriesModal:false,
		        title:'',
		        dataList:[
		        	{
		        		name:'Time for a new watch (this story)',
		        		id:1
		        	},
		        	{
		        		name:'Time for a new watch',
		        		id:2
		        	},
		        ],
			}
		},

		methods: {
			showBtmBar()  {
				this.btmBar=!this.btmBar;
	     		EventBus.$emit('showBtm', this.btmBar);
			},
			showModals() {
				this.showModal=true;
			},
			closeModal() {
				this.showModal=false;
				this.seriesModal=false;
			},
			seriesModalClose() {
				this.seriesModal=false;
			},
			closeStoryModal() {
				this.showModal=false;
				this.seriesModal=true;
			},

			//push title
			addTitle(){
				if(this.title.length==0) {
					alert("Title field can not be empty.");
				} else {
					this.dataList.push({
						name: this.title,
						id:this.dataList.length+1 
					});
					this.title='';
				}
			},
			removeTitle(data, index) {
				this.dataList.splice(index, 1)
			},
			saveData() {
				this.seriesModal=false;
				this.$noty.success("Data has been saved successfully.");
			}

		},

		components: {
	        draggable,
	    },
	    created() {
		  	// Using the server bus
			EventBus.$on('showModals', data => {
			  this.showModal=data;
			});
		}
	}
</script>



<style>
	@import '../assets/css/main-content.css';
	.singleStoryTitle,
	.flip-list-move {
	  -webkit-transition: -webkit-transform 0.5s;
	  transition: -webkit-transform 0.5s;
	  -o-transition: transform 0.5s;
	  transition: transform 0.5s;
	  transition: transform 0.5s, -webkit-transform 0.5s;
	}
	.no-move {
	  -webkit-transition: -webkit-transform 0s;
	  transition: -webkit-transform 0s;
	  -o-transition: transform 0s;
	  transition: transform 0s;
	  transition: transform 0s, -webkit-transform 0s;
	}
</style>